import React, {useEffect, useState} from 'react'
import CardItem from '../CardItem'
import './../Cards.css';
import { fetchCategories } from '../../lib/ShopifyUtility';
import LoadingPage from '../pages/LoadingPage';

const MarketMenuCategories = () => {

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const customOrder = ["Supper Dishes", "Puddings"];
    fetchCategories().then((fetchedCategories) => {
      // Sort fetched categories according to customOrder
      const sortedCategories = fetchedCategories?.sort((a, b) => {
        return customOrder.indexOf(a.title) - customOrder.indexOf(b.title);
      });

      setCategories(sortedCategories);
    });
  }, []);

    return (
      !categories.length ? <LoadingPage height="600px"/> :
          <div className='cards__container'>
            <div className='cards__wrapper'>
              <ul className='cards__items'>
                {categories.map((category) => (
                    <CardItem
                        src={(category.image && category.image.src ? category.image.src : require('../../images/category_default.png'))}
                        text={category.title.toUpperCase()}
                        path={category.handle}
                        isLink={true}
                        key={category.id}
                    />
                ))}
              </ul>
            </div>
          </div>
    )
  }

export default MarketMenuCategories
